/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_One_TimeInputs */

const en_settings_payments_tab_one_time = /** @type {(inputs: Settings_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time`)
};

/**
* | output |
* | --- |
* | "One-time" |
*
* @param {Settings_Payments_Tab_One_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_one_time = /** @type {((inputs?: Settings_Payments_Tab_One_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_One_TimeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_tab_one_time(inputs)
});
export { settings_payments_tab_one_time as "settings.payments.tab_one_time" }